import { Injectable, EventEmitter, Output } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEvent, HttpRequest } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Audit } from '../models/audit';
import { AuditCtgc } from '../models/auditCtgc';
import { Country } from '../models/country';
import { AppConfig } from '../config/app-config';
import { AuditActivator } from '../models/auditActivator';

@Injectable({
    providedIn: 'root'
})
export class AuditService {
    constructor(private http: HttpClient, private appConfig: AppConfig) { }

    headers = new HttpHeaders();

    getAuditList(countryId: string, dateFrom: string, dateSince: string, indexAuditType: string, user: string): Observable<Audit[]> {
        let params = new HttpParams()
            .set("countryId", countryId !== null ? countryId.toString() : '')
            .set("dateFrom", dateFrom !== null ? dateFrom.toString() : '')
            .set("dateSince", dateSince !== null ? dateSince.toString() : '')
            .set("indexAuditType", indexAuditType !== null ? indexAuditType.toString() : '')
            .set("user", user !== null ? user.toString() : '');

        return this.http.get<any>(this.appConfig.urlKeysApi + 'Audit/GetAuditList', { params: params })
    }

    getAuditListCtgc(countryId: string, dateFrom: string, dateSince: string, indexAuditType: string, user: string): Observable<AuditCtgc[]> {
        let params = new HttpParams()
            .set("countryId", countryId !== null ? countryId.toString() : '')
            .set("dateFrom", dateFrom !== null ? dateFrom.toString() : '')
            .set("dateSince", dateSince !== null ? dateSince.toString() : '')
            .set("indexAuditType", indexAuditType !== null ? indexAuditType.toString() : '')
            .set("user", user !== null ? user.toString() : '');

        return this.http.get<any>(this.appConfig.urlKeysApi + 'Audit/GetAuditCtgcList', { params: params })
    }

    getAuditActivatorList(dateFrom: string, dateSince: string, user: string): Observable<AuditActivator[]> {
        let params = new HttpParams()
            .set("dateFrom", dateFrom !== null ? dateFrom.toString() : '')
            .set("dateSince", dateSince !== null ? dateSince.toString() : '')
            .set("user", user !== null ? user.toString() : '');

        return this.http.get<any>(this.appConfig.urlKeysApi + 'Audit/GetAuditActivatorList', { params: params })
    }

    GetAuditLogCountryConflicts(countryId: string, dateFrom: string, dateSince: string, user: string): Observable<number[]> {
        let params = new HttpParams()
            .set("countryId", countryId !== null ? countryId.toString() : '')
            .set("dateFrom", dateFrom !== null ? dateFrom.toString() : '')
            .set("dateSince", dateSince !== null ? dateSince.toString() : '')
            .set("user", user !== null ? user.toString() : '');

        return this.http.get<any>(this.appConfig.urlKeysApi + 'Audit/GetAuditLogCountryConflicts', { params: params })
    }

    getCountriesList(): Observable<Country[]> {
        return this.http.get<any>(this.appConfig.urlKeysApi + 'Audit/GetCountriesList');
    }

    uploadFiles(formData): Observable<any> {
        const uploadReq = new HttpRequest('POST', this.appConfig.urlKeysApi + "Audit/UploadFiles", formData, {
            reportProgress: true,
        });
        return this.http.request(uploadReq);
    }

    ExportAudit(usr, startDate, endDate): Observable<any> {
        startDate = startDate != null ? startDate.toString() : '';
        endDate = endDate != null ? endDate.toString() : '';
        return this.http.get(this.appConfig.urlKeysApi + "Audit/ExportAudit?usr=" + usr + "&startDate=" + startDate + "&endDate=" + endDate, { responseType: 'blob' });
    }

    ExportAuditCountry(usr, indexAuditType, startDate, endDate, countryId): Observable<any> {
        indexAuditType = indexAuditType != null ? indexAuditType.toString() : '';
        startDate = startDate != null ? startDate.toString() : '';
        endDate = endDate != null ? endDate.toString() : '';
        countryId = countryId != null ? countryId.toString() : '';
        return this.http.get(this.appConfig.urlKeysApi + "Audit/ExportAuditCountry?usr=" + usr + "&indexAuditType=" + indexAuditType + "&startDate=" + startDate + "&endDate=" + endDate + "&countryId=" + countryId, { responseType: 'blob' });
    }

}
